import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { Switch, Tooltip, Typography } from "@mui/material"
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import TranslatedText from "../../../utils/Translate"
import { languageOptions, clientLanguageOptions } from "../../../utils/LanguageList";
import { RepeatcallsDecode, targetActiveTransfersDecode, targetActiveTransfersEncode, TerminalstatusesDecode, TimeDecode, TimeEncode } from "../../../utils/prepareJSON"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function Campaign() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [contactGroups, setContactGroups] = React.useState([]);
    const [campaigns, setCampaigns] = React.useState([]);
    const [channels, setChannels] = useState([])

    dayjs.extend(utc);
    dayjs.extend(timezone);

    // Задаём дефолтную зону
    dayjs.tz.setDefault('Europe/Moscow');

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit Campaign` : 'Add Campaign'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get campaign
    async function fetchData(params: object = {}) {
        //Заменить энд поинт на компании - как будет готов!!!!
        try {
            const campaignsL = await getCampaigns();
            const response = await axios.get(`https://cardgarantsales.com/restapi/campaign/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {

                    setCampaignData({
                        ...response.data[0],
                        repeatcalls: response.data[0].repeatcalls ? RepeatcallsDecode(response.data[0].repeatcalls) : '',
                        terminalstatuses: response.data[0].terminalstatuses ? TerminalstatusesDecode(response.data[0].terminalstatuses) : '',
                        targetactivetransfers: response.data[0].targetactivetransfers ? targetActiveTransfersDecode(response.data[0].targetactivetransfers, campaignsL) : '',
                        maxactivetransfers: response.data[0].maxactivetransfers ? targetActiveTransfersDecode(response.data[0].maxactivetransfers, campaignsL) : '',
                        emails: response.data[0].emails ? JSON.parse(response.data[0].emails).join(';') : '',
                        campaignactivetime: response.data[0].campaignactivetime ? TimeDecode(response.data[0].campaignactivetime) : '',
                        clientactivetime: response.data[0].clientactivetime ? TimeDecode(response.data[0].clientactivetime) : '',
                        newleadsperdaylimit: response.data[0].newleadsperdaylimit ? JSON.parse(response.data[0].newleadsperdaylimit).limit : '',
                        leaddatefrom: response.data[0].leaddatefrom,
                        leaddateto: response.data[0].leaddateto,
                        campaigndatestart: response.data[0].campaigndatestart,
                        removefromleadgroup: `${response.data[0].removefromleadgroup}`,
                    })
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const checkDate = (el: any) => {
        if (el !== null && typeof (el) !== "string") {
            if (el.isValid()) {
                return true
            }
        }
        else return false
    }


    //Create campaign
    //Заменить энд поинт на компании - как будет готов!!!!
    async function postData(data: any = {}) {
        try {
            const campaignsL = await getCampaigns();
            const response = await axios.post(`https://cardgarantsales.com/restapi/campaign`, {
                ...data,
                targetactivetransfers: targetActiveTransfersEncode(data.targetactivetransfers, campaignsL),
                maxactivetransfers: targetActiveTransfersEncode(data.maxactivetransfers, campaignsL),
                leaddatefrom: data.leaddatefrom || null,
                leaddateto: data.leaddateto || null,
                campaigndatestart: data.campaigndatestart || null,
                campaignactivetime: TimeEncode(data.campaignactivetime),
                clientactivetime: TimeEncode(data.clientactivetime),

            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit campaign
    async function putData(data: any = {}) {
        try {

            const campaignsL = await getCampaigns();
            const response = await axios.put(`https://cardgarantsales.com/restapi/campaign/${id}`, {
                ...data,
                targetactivetransfers: targetActiveTransfersEncode(data.targetactivetransfers, campaignsL),
                maxactivetransfers: targetActiveTransfersEncode(data.maxactivetransfers, campaignsL),
                leaddatefrom: data.leaddatefrom || null,
                leaddateto: data.leaddateto || null,
                campaigndatestart: data.campaigndatestart || null,
                campaignactivetime: TimeEncode(data.campaignactivetime),
                clientactivetime: TimeEncode(data.clientactivetime),
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [campaignData, setCampaignData] = useState<any>(type === 'edit' ? [] :
        {
            "id": null,
            "status": '0',
            "targetload": null,
            "targetactivetransfers": null,
            "maxactivetransfers": null,
            "partner": null,
            "campaigncode": null,
            "campaignname": null,
            "parentcampaign": null,
            "campaigndatestart": null,
            "channel": null,
            "language_client": null,
            "language_translation": null,
            "conversationtemplate": null,
            "emails": null,
            "leadgroup": null,
            "removefromleadgroup": '0',
            "leaddatefrom": null,
            "leaddateto": null,
            "relativeleaddatefrom": null,
            "relativeleaddateto": null,
            "isclosed": '',
            "campaignactivetime": null,
            "clientactivetime": null,
            "repeatcalls": null,
            "newleadsperdaylimit": null,
            "leadgroupfulfilled": null,
            "terminalstatusfield": null,
            "terminalstatuses": null,

        }
    )

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setSPartners(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setConversationtemplates(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Making request to get channels list
    async function getChannels(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/channelselector`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setChannels(response.data)

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    async function getContactGroups(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/contactgroup`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setContactGroups(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    async function getCampaigns(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/campaign`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    const convertedList = response.data.reduce((acc: any, item: any) => {
                        acc[item.id] = item.campaigncode;
                        return acc;
                    }, {});
                    setCampaigns(response.data)
                    return convertedList;
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //On load if URL params contains type=edit
    useEffect(() => {
        type != 'edit' && getCampaigns()
        type === 'edit' && fetchData()
        getPartners()
        getConversationtemplates()
        getContactGroups()
        getChannels()
        console.log(campaignData);

    }, [type])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ maxWidth: 1220, width: '90vw', display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <Typography mb={2} variant="h6" width={'100%'} textAlign={'center'}><TranslatedText text={'Main parameters'} /></Typography>
                    <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap', gap: 2 }}>


                        {<FormControl sx={{ flex: "1 0 10rem" }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Status'} /></InputLabel>
                            <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, status: e.target.value !== "" ? e.target.value : null })} value={campaignData.status || ''} variant="outlined" size="small" label={<TranslatedText text={'Status'} />} >
                                <MenuItem value={'0'}><TranslatedText text={'Stopped'} /></MenuItem>
                                <MenuItem value={'1'}><TranslatedText text={'Running'} /></MenuItem>
                                <MenuItem value={'2'}><span><TranslatedText text={'Stopped by a robot'} /> - <TranslatedText text={'the calls are not going through'} />!</span></MenuItem>
                                <MenuItem value={'3'}><span><TranslatedText text={'Started'} /> - <TranslatedText text={'no contacts'} /></span></MenuItem>
                                <MenuItem value={'4'}><span><TranslatedText text={'Started'} /> - <TranslatedText text={'break'} /></span></MenuItem>
                            </Select>
                        </FormControl>}
                        <TextField sx={{ flex: "1 0 10rem" }} onChange={(e) => setCampaignData({ ...campaignData, targetload: e.target.value !== '' ? e.target.value : null })} value={campaignData.targetload || ''} variant="outlined" size="small" label={<span><TranslatedText text={'Time between calls'} /> (<TranslatedText text={'sec'} />)*</span>} />
                        {accesslevel === '5' && <FormControl sx={{ flex: "1 0 10rem" }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} /></InputLabel>
                            <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, partner: e.target.value !== "" ? e.target.value : null })} value={campaignData.partner || ''} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                                <MenuItem value={''}><TranslatedText text={'Not selected'} /></MenuItem>
                                {
                                    partners.map((el: any) => {
                                        return (
                                            <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>}
                        <TextField sx={{ flex: "1 0 10rem" }} onChange={(e) => setCampaignData({ ...campaignData, campaigncode: e.target.value !== '' ? e.target.value : null })} value={campaignData.campaigncode || ''} variant="outlined" size="small" label={<span><TranslatedText text={'Code'} />*</span>} />
                        <TextField sx={{ flex: "1 0 10rem" }} onChange={(e) => setCampaignData({ ...campaignData, campaignname: e.target.value !== '' ? e.target.value : null })} value={campaignData.campaignname || ''} variant="outlined" size="small" label={<TranslatedText text={'Name'} />} />
                    </Box>
                    <Tooltip title={<span><TranslatedText text={"In the format"} /> &lt;<TranslatedText text={'campaign 1 code'} />&gt;+&lt;<TranslatedText text={'campaign 2 code'} />&gt; = &lt;<TranslatedText text={'target number of transfers'} />&gt;</span>} placement="top-start">
                        <TextField sx={{ width: '100%' }} onChange={(e) => setCampaignData({ ...campaignData, targetactivetransfers: e.target.value !== '' ? e.target.value : null })} value={campaignData.targetactivetransfers || ''} variant="outlined" size="small" label={<TranslatedText text={'Target number of active transfers'} />} />
                    </Tooltip>
                    <Tooltip title={<span><TranslatedText text={"In the format"} /> &lt;<TranslatedText text={'campaign 1 code'} />&gt;+&lt;<TranslatedText text={'campaign 2 code'} />&gt; = &lt;<TranslatedText text={'max. number of transfers'} />&gt;</span>} placement="top-start">
                        <TextField sx={{ width: '100%' }} onChange={(e) => setCampaignData({ ...campaignData, maxactivetransfers: e.target.value !== '' ? e.target.value : null })} value={campaignData.maxactivetransfers || ''} variant="outlined" size="small" label={<TranslatedText text={'Maximum number of active transfers'} />} />
                    </Tooltip>



                    {<FormControl sx={{ width: '100%' }}>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Parent Campaign"} /> (<TranslatedText text={"Total count of the number of calls to the client"} />)</InputLabel>
                        <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, parentcampaign: e.target.value !== "" ? e.target.value : null })} value={campaignData.parentcampaign || ''} variant="outlined" size="small" label={<span><TranslatedText text={"Parent Campaign"} /> (<TranslatedText text={"Total count of the number of calls to the client"} />)</span>} >
                            <MenuItem value={''}><TranslatedText text={"Not selected"} /></MenuItem>
                            {
                                campaigns.map((el: any) => {
                                    return (
                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode} - {el.campaigncode}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>}

                    <DateTimePicker label={<TranslatedText text={'Date/time of the campaign start'} />} sx={{ width: '100%' }} slotProps={{ textField: { size: 'small' } }} value={campaignData.campaigndatestart ? dayjs.tz(campaignData.campaigndatestart, 'Europe/Moscow') : null} onChange={(e) => {
                        if (e && !e.isValid()) return;
                        setCampaignData({ ...campaignData, campaigndatestart: e ? e.tz('Europe/Moscow').format('YYYY-MM-DD HH:mm') : '' });
                        }} format="YYYY-MM-DD HH:mm" />
                    {<FormControl sx={{ width: '100%' }}>
                        <InputLabel size="small" id="simple-select-label"><span><TranslatedText text={'Channel for calls'} />*</span></InputLabel>
                        <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, channel: e.target.value !== "" ? e.target.value : null })} value={campaignData.channel || ''} variant="outlined" size="small" label={<span><TranslatedText text={'Channel for calls'} />*</span>} >
                            <MenuItem value={''}><TranslatedText text={'Not selected'} /></MenuItem>
                            {
                                channels.map((option: any) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>}
                    {<FormControl sx={{ width: '100%' }}>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Clients language'} /> (<TranslatedText text={'Lower priority than in Contact'} />)</InputLabel>
                        <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, language_client: e.target.value !== "" ? e.target.value : null })} value={campaignData.language_client || ''} variant="outlined" size="small" label={<span><TranslatedText text={'Clients language'} /> (<TranslatedText text={'Lower priority than in Contact'} />)</span>} >
                            <MenuItem value={''}><TranslatedText text={'Not selected'} /></MenuItem>
                            {clientLanguageOptions.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>}
                    {<FormControl sx={{ width: '100%' }}>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Translation language'} /></InputLabel>
                        <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, language_translation: e.target.value !== "" ? e.target.value : null })} value={campaignData.language_translation || ''} variant="outlined" size="small" label={<TranslatedText text={'Translation language'} />}>
                            <MenuItem value={''}><TranslatedText text={'Not selected'} /></MenuItem>
                            {languageOptions.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>}
                    <FormControl sx={{ width: '100%' }}>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Conversation template'} />*</InputLabel>
                        <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, conversationtemplate: e.target.value !== '' ? e.target.value : null })} value={campaignData.conversationtemplate || ''} variant="outlined" size="small" label={<TranslatedText text={'Conversation template'} />} >
                            {
                                conversationtemplates.map((el: any) => {
                                    //make conversationtemplate list item
                                    return (
                                        <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <TextField sx={{ width: '100%' }} onChange={(e) => setCampaignData({ ...campaignData, emails: e.target.value !== '' ? e.target.value : null })} value={campaignData.emails || ''} variant="outlined" size="small" label={<span><TranslatedText text={'Email of the administrator'} /> (<TranslatedText text={'several - via'} /> ";")</span>} />
                    <Typography mb={2} variant="h6" width={'100%'} textAlign={'center'}><TranslatedText text={'Contact selection parameters'} /></Typography>
                    <FormControl sx={{ width: '100%' }}>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Initial Contact Group'} /></InputLabel>
                        <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, leadgroup: e.target.value !== '' ? e.target.value : null })} value={campaignData.leadgroup || ''} variant="outlined" size="small" label={<TranslatedText text={'Initial Contact Group'} />} >
                            {
                                contactGroups.map((el: any) => {
                                    return (
                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode} - {el.leadgroupcode}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography><TranslatedText text={'Delete contacts from the initial group'} /></Typography>
                        <Switch onChange={(e) => setCampaignData({ ...campaignData, removefromleadgroup: campaignData.removefromleadgroup === '0' ? '1' : '0' })} checked={Boolean(+campaignData.removefromleadgroup)} />
                    </Box>
                    <DatePicker label={<TranslatedText text={'Contact date from'} />} sx={{ width: '100%' }} slotProps={{ textField: { size: 'small'} }} value={campaignData.leaddatefrom ? dayjs.tz(campaignData.leaddatefrom, 'Europe/Moscow') : null} onChange={(e) => {
                        if (e && !e.isValid()) return;
                        setCampaignData({ ...campaignData, leaddatefrom: e ? e.tz('Europe/Moscow').format('YYYY-MM-DD') : '' });
                        }} format="YYYY-MM-DD" />
                    <DatePicker label={<TranslatedText text={'Contact date to'} />} sx={{ width: '100%' }} slotProps={{ textField: { size: 'small' } }} value={campaignData.leaddateto ? dayjs.tz(campaignData.leaddateto, 'Europe/Moscow') : null} onChange={(e) => {
                        if (e && !e.isValid()) return;
                        setCampaignData({ ...campaignData, leaddateto: e ? e.tz('Europe/Moscow').format('YYYY-MM-DD') : '' });
                        }} format="YYYY-MM-DD" />
                    <Tooltip title={<TranslatedText text={"Specify in days, for example: -3"} />} placement="top-start">
                        <TextField sx={{ width: '100%' }} onChange={(e) => setCampaignData({ ...campaignData, relativeleaddatefrom: e.target.value !== '' ? e.target.value : null })} value={campaignData.relativeleaddatefrom || ''} variant="outlined" size="small" label={<TranslatedText text={'The date of the contacts is relative to the current date from'} />} />
                    </Tooltip>
                    <Tooltip title={<TranslatedText text={"Specify in days, for example: 0"} />} placement="top-start">
                        <TextField sx={{ width: '100%' }} onChange={(e) => setCampaignData({ ...campaignData, relativeleaddateto: e.target.value !== '' ? e.target.value : null })} value={campaignData.relativeleaddateto || ''} variant="outlined" size="small" label={<TranslatedText text={'The date of the contacts is relative to the current date to'} />} />
                    </Tooltip>
                    <FormControl sx={{ width: '100%' }}>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Contact status"} /></InputLabel>
                        <Select key={campaignData.isclosed} sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, isclosed: e.target.value !== "" ? e.target.value : null })} value={campaignData.isclosed || ''} variant="outlined" size="small" label={<TranslatedText text={'Contact status'} />} >
                            <MenuItem value={''}><TranslatedText text={"Any"} /></MenuItem>
                            <MenuItem value={'0'}><TranslatedText text={"Open"} /></MenuItem>
                            <MenuItem value={'1'}><TranslatedText text={"Closed"} /></MenuItem>
                        </Select>
                    </FormControl>
                    <Typography mb={2} variant="h6" width={'100%'} textAlign={'center'}><TranslatedText text={"The rules of calling"} /></Typography>
                    <Tooltip title={<TranslatedText text={'Time of calls (robot; time zone of the robot;every day of the week in a new row;e.g.: Tuesday:09:00-13:00,14:00-18:00;if the day of the week is not specified, it means that on this day you can at any time;if the day of the week is specified, but without intervals, then it is impossible on this day at any time)'} />} placement="top-start">
                        <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                            label={<TranslatedText text={"The rules of calling"} />}
                            onChange={(e) => setCampaignData({ ...campaignData, campaignactivetime: e.target.value !== '' ? e.target.value : null })}
                            value={campaignData.campaignactivetime || ''}
                            multiline
                            rows={5}
                            fullWidth
                            variant="outlined" />
                    </Tooltip>
                    <Tooltip title={<TranslatedText text={'Time of calls (client; client`s time zone;every day of the week in a new row;e.g.: Tuesday:09:00-13:00,14:00-18:00;if the day of the week is not specified, it means that on this day you can at any time;if the day of the week is specified, but without intervals, then it is impossible on this day at any time)'} />} placement="top-start">
                        <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                            label={<TranslatedText text={'Time of calls to the client'} />}
                            onChange={(e) => setCampaignData({ ...campaignData, clientactivetime: e.target.value !== '' ? e.target.value : null })}
                            value={campaignData.clientactivetime || ''}
                            multiline
                            rows={5}
                            fullWidth
                            variant="outlined" />
                    </Tooltip>
                    <Tooltip title={<TranslatedText text={"Call schedule (minimum time between calls if terminal status is not reached; <min. time between calls>=<priority of this stage of the call (optional - by request. 1)>; the first pair <time>=<priority> refers to the delay and priority of the first stage of the call;the higher priority is processed first; expample: 1h=3.3h=1.1d,5d,30d)"} />} placement="top-start">
                        <TextField sx={{ width: '100%' }} onChange={(e) => setCampaignData({ ...campaignData, repeatcalls: e.target.value !== '' ? e.target.value : null })} value={campaignData.repeatcalls || ''} variant="outlined" size="small" label={<TranslatedText text={'Call schedule'} />} />
                    </Tooltip>
                    <TextField sx={{ width: '100%' }} onChange={(e) => setCampaignData({ ...campaignData, newleadsperdaylimit: e.target.value !== '' ? e.target.value : null })} value={campaignData.newleadsperdaylimit || ''} variant="outlined" size="small" label={<TranslatedText text={'Daily limit for processing new contacts'} />} />
                    <FormControl sx={{ width: '100%' }}>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={"A group of contacts for revision (for those who have not reached terminal status after all calls)"} /></InputLabel>
                        <Select sx={{ width: '100%' }} labelId="simple-select-label" onChange={(e) => setCampaignData({ ...campaignData, leadgroupfulfilled: e.target.value !== '' ? e.target.value : null })} value={campaignData.leadgroupfulfilled || ''} variant="outlined" size="small" label={<TranslatedText text={"A group of contacts for revision (for those who have not reached terminal status after all calls)"} />} >
                            {
                                contactGroups.map((el: any) => {
                                    return (
                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode} - {el.leadgroupcode}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <Tooltip title={<span><TranslatedText text={'For example'} />:  final_status</span>} placement="top-start">
                        <TextField sx={{ width: '100%' }} onChange={(e) => setCampaignData({ ...campaignData, terminalstatusfield: e.target.value !== '' ? e.target.value : null })} value={campaignData.terminalstatusfield || ''} variant="outlined" size="small" label={<TranslatedText text={'The field for calculating the terminal status'} />} />
                    </Tooltip>
                    <Tooltip title={<TranslatedText text={'Each in a new line; <substring in the final status field>=<group where to place the contact (optional)>; for example: refusal=Refuseniks; interested=Converted; busy=A group to call back; negative'} />} placement="top-start">
                        <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                            label={<TranslatedText text={'Terminal statuses'} />}
                            onChange={(e) => setCampaignData({ ...campaignData, terminalstatuses: e.target.value !== '' ? e.target.value : null })}
                            value={campaignData.terminalstatuses || ''}
                            multiline
                            rows={5}
                            fullWidth
                            variant="outlined" />
                    </Tooltip>
                </Box>
                {<Button onClick={() => type === "edit" ? putData(campaignData) : postData(campaignData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={'Save'} /></Button>}
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/campaigns' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}